module.exports = __webpack_public_path__ + "assets/img/user.292bf701.svg";